/*
 * @Description: 个人中心 企业管理
 */
import {
  CompanyInviteLinkAgeLimitEnum,
  CompanyMemberListStatusEnum,
  CompnayProductMemberStatusEnum,
} from '../types/company'
import type {
  CompanyEnergyPointListItem,
  CompanyInviteLinkVerifyCodeEnum,
  CompanyMemberListModel,
  CompanyProductDetil
  ,
  CompanyProductModel,
} from '../types/company'
import { get, post } from '@/utils/request'
/**
 * 1. 创建企业，全局接口，放在公用api中
 * 2. 获取企业列表（workpace)，全局接口，放在公用api中
 * 3. 添加企业成员（当前企业下）
 * 4. 获取企业成员列表（当前企业下）
 * 5. 创建企业成员邀请链接（当前企业下）
 * 6. 校验企业成员邀请链接的有效性（当前企业下）
 * 7. 核销企业成员邀请链接（当前企业下）
 * 8. 获取企业成员统计 侧栏菜单数据 （当前企业下）
 */

// 添加企业成员
export function addComapnyMember(data: {
  enterpriseId: number
  inviteeId: number
  memberId?: number
}) {
  return post<{ resultMsg: string }>({
    url: '/assistant/enterprise/member/addMember',
    data,
  })
}

// 获取企业成员列表
export function getCompanyMemberList(data: {
  enterpriseId: number // 企业id
  keyword?: string // 搜索成员手机号码/微信昵称
  page?: number
  pageSize?: number
  status?: CompanyMemberListStatusEnum
}) {
  const requestData = {
    page: 1,
    pageSize: 10,
    status: CompanyMemberListStatusEnum.All,
    ...data,
  }
  return post<CompanyMemberListModel>({
    url: '/assistant/enterprise/member/list',
    data: requestData,
  })
}

// 创建企业成员邀请链接
export function createInviteLink(data: {
  enterpriseId: number
  ageLimit?: CompanyInviteLinkAgeLimitEnum
}) {
  const requestData = {
    ageLimit: CompanyInviteLinkAgeLimitEnum.Permanent,
    ...data,
  }
  return post<{ model: string }>({
    url: '/assistant/enterprise/member/invite/url',
    data: requestData,
  })
}

// 校验企业成员邀请链接的有效性
export function verifyCompanyInviteCode(data: {
  code: string
  enterpriseId: number
  inviteId: number
}) {
  return post<{ code: number; desc: string }>({
    url: '/assistant/enterprise/member/invite/verifyUrl',
    data,
  })
}

// 核销企业成员邀请链接
export function checkoutVerifyCompanyInvite(data: {
  code: string
  enterpriseId: number
  inviteId: number
}) {
  return post<{
    code: CompanyInviteLinkVerifyCodeEnum
  }>({
    url: '/assistant/enterprise/member/invite/join',
    data,
  })
}

// 获取企业成员统计 侧栏菜单数据
export function getMemberStats(data: {
  enterpriseId: number
  archiveId?: number
}) {
  return post<{
    adminCount: number
    applyCount: number
    exitCount: number
    memberCount: number
    totalCount: number
  }>({
    url: '/assistant/enterprise/member/stats',
    data,
  })
}

// 获取企业能量点总揽
export function getCompanyEnergyPointSummary(data: {
  enterpriseId: number
}) {
  const requestData = {
    page: 1,
    pageSize: 10,
    ...data,
  }
  return post<{
    balance: number
    usedAmount: number
    expirationSoonAmount: number
    expirationAmount: number
  }>({
    url: '/assistant/enterprise/amount/overview',
    data,
  })
}
// 获取企业能量点明细

export function getCompanyEnergyPointList(data: {
  enterpriseId: number
  page?: number
  pageSize?: number
  name?: string
}) {
  const requestData = {
    page: 1,
    pageSize: 10,
    ...data,
  }
  return post<{
    total: number
    records: CompanyEnergyPointListItem[]
  }>({
    url: '/assistant/enterprise/amount/detailList',
    data: requestData,
  })
}

// 审核加入企业的申请
export function reviewJoinCompanyApply(data: {
  enterpriseId: number // 企业id
  code: number // 审核状态码
  applyId: number // 申请记录ID
}) {
  return post({
    url: '/assistant/enterprise/apply/review',
    data,
  })
}

// 移除成员（企业）
export function removeCompanyMember(data: {
  enterpriseId: number // 企业id
  memberId: number // 成员id
}) {
  return post({
    url: '/assistant/enterprise/member/removeMember',
    data,
  })
}

// 修改成员消耗限制
export function updateMemberLimit(data: {
  enterpriseId: number // 企业id
  memberId: number // 成员id
  limitType: number // 限制类型 企业能量点消费规则 0：不限制 1：月消耗限制 2：分配能量点
  limitAmount: number | string // 限制数量
}) {
  return post({
    url: '/assistant/enterprise/member/editConsumerRule',
    data,
  })
}

// 修改成员权限
export function updateMemberPermission(data: {
  enterpriseId: number // 企业id
  memberId: number // 成员id
  permissions: number[] // 权限列表 拥有的权限 1：管理知识库 2：创建产品
}) {
  return post({
    url: '/assistant/enterprise/member/editMemberPermission',
    data,
  })
}

// 转让企业管理员权限
export function transferCompnayAdmin(data: {
  enterpriseId: number // 企业id
  memberId: number // 成员id
}) {
  return post({
    url: '/assistant/enterprise/member/transferAdmin',
    data,
  })
}

// 手机号码匹配用户
export function matchUserByPhone(phone: string) {
  return get<{
    nickName: string
    headerImg: string
    id: number
    phone: string
  }>({
    url: `/assistant/user/getByPhone?phoneNumber=${phone}`,
  })
}

// ------------------ 以下企业产品相关 --------------------------- //

// 获取企业产品列表
export function getCompanyProductList(data: {
  enterpriseId: number
  page?: number
  pageSize?: number
  productName?: string
}) {
  const requestData = {
    page: 1,
    pageSize: 10,
    ...data,
  }
  return post<CompanyProductModel>({
    url: '/assistant/enterprise/archiveList',
    data: requestData,
  })
}

// 单个产品信息查看
export function getCompanyProductDetail(data: {
  enterpriseId: number
  archiveId: number
}) {
  return post<CompanyProductDetil>({
    url: '/assistant/archive/get',
    data,
  })
}

// 企业产品成员统计
export function getProductMemberStats(data: {
  enterpriseId: number
  archiveId: number
}) {
  return post<{
    adminCount: number
    applyCount: number
    exitCount: number
    ordinaryCount: number
    totalCount: number
  }>({
    url: '/assistant/enterprise/member/archive/stats',
    data,
  })
}

// 获取产品邀请链接
export function createProductInviteLink(data: {
  enterpriseId: number
  ageLimit?: CompanyInviteLinkAgeLimitEnum
  archiveId: number
  scope: number // 企业产品被邀请人的范围 0：不限 1：企业成员
}) {
  const requestData = {
    ageLimit: CompanyInviteLinkAgeLimitEnum.Permanent,
    ...data,
  }
  return post<{ model: string }>({
    url: '/assistant/enterprise/archive/invite/url',
    data: requestData,
  })
}

// 企业产品链接校验
export function verifyCompanyProductInviteLink(data: {
  code: number
  enterpriseId: number
  inviteId: number
  scope: number // 企业产品被邀请人的范围 0：不限 1：企业成员
}) {
  return post({
    url: '/assistant/enterprise/archive/invite/verifyUrl',
    data,
  })
}

// 企业产品链接核销
export function checkoutVerifyCompanyProductInvite(data: {
  code: number
  enterpriseId: number
  inviteId: number
  scope: number // 企业产品被邀请人的范围 0：不限 1：企业成员
}) {
  return post({
    url: '/assistant/enterprise/archive/invite/join',
    data,
  })
}

// 企业产品成员列表
export function getProductMemberList(data: {
  enterpriseId: number
  archiveId: number
  keyword?: string
  page?: number
  pageSize?: number
  status?: CompnayProductMemberStatusEnum
}) {
  const requestData = {
    page: 1,
    pageSize: 10,
    status: CompnayProductMemberStatusEnum.All,
    ...data,
  }
  return post<CompanyMemberListModel>({
    url: '/assistant/enterprise/member/archive/list',
    data: requestData,
  })
}

// 企业产品可选择成员列表 获取可添加协作的企业成员
export function getSelectableMemberList(data: {
  enterpriseId: number
  archiveId: number
  keyword?: string
  page?: number
  pageSize?: number
}) {
  const requestData = {
    page: 1,
    pageSize: 10,
    ...data,
  }
  return post<CompanyMemberListModel>({
    url: '/assistant/enterprise/member/archive/selectableList',
    data: requestData,
  })
}

// 企业添加协作的企业成员  批量
export function addProductMember(data: {
  enterpriseId: number
  archiveId: number
  userIds: number[]
}) {
  return post({
    url: '/assistant/enterprise/archive/addMember',
    data,
  })
}

// 移除成员(企业产品)
export function removeProductMember(data: {
  enterpriseId: number
  archiveId: number
  memberId: number
}) {
  return post({
    url: '/assistant/enterprise/archive/removeMember',
    data,
  })
}

// 审核加入企业产品的申请
export function reviewJoinCompanyProductApply(data: {
  enterpriseId: number // 企业id
  code: number // 审核状态码
  applyId: number // 申请记录ID
  archiveId: number // 产品id
}) {
  return post({
    url: '/assistant/enterprise/apply/archive/review',
    data,
  })
}

// 修改产品成员权限
export function updateMemberProductRole(data: {
  enterpriseId: number // 企业id
  memberId: number // 成员id
  archiveId: number // 产品id
  role: number //
}) {
  return post({
    url: '/assistant/enterprise/archive/editRole',
    data,
  })
}

// 可移交的企业产品成员列表
export function getTransferableProductMemberList(data: {
  enterpriseId: number // 企业id
  archiveId: number // 产品id
}) {
  return post<CompanyMemberListModel>({
    url: '/assistant/enterprise/member/archive/getTransferable',
    data,
  })
}
// 转让企业产品管理员权限
export function transferCompnayProductAdmin(data: {
  enterpriseId: number // 企业id
  memberId: number // 成员id
  archiveId: number // 产品id
}) {
  return post({
    url: '/assistant/enterprise/archive/transferAdmin',
    data,
  })
}

// 申请加入企业产品
export function applyJoinCompanyProduct(data: {
  archiveId: number // 产品id
  enterpriseId: number // 企业id
}) {
  return post({
    url: '/assistant/enterprise/archive/apply/join',
    data,
  })
}
